// extracted by mini-css-extract-plugin
export default {"onboarding__box":"HomeOnboarding_onboarding__box__7aPmh"};